import { useMemo } from 'react'
import { formattersFor, type EntryFormatters } from './format'
import { useLanguage } from './use-language'

/** 지금 화면 언어의 표기 형식기. 언어가 바뀌면 지난 기록의 날짜 머리도 함께 갈린다. */
export function useEntryFormatters(): EntryFormatters {
  const { languageId } = useLanguage()
  return useMemo(() => formattersFor(languageId), [languageId])
}
